import React, { useState } from 'react';

const WalletDeleteModal = ({ wallet, onClose, onConfirm }) => {
  const [acknowledged, setAcknowledged] = useState(false);
  
  if (!wallet) return null;
  
  
  const handleConfirmDelete = () => {
    if (acknowledged) {
      onConfirm(wallet);
    }
  };
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 dark:bg-black dark:bg-opacity-70 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-xl p-6 max-w-lg w-full mx-4 transition-colors">
        <h2 className="text-xl font-bold text-gray-800 dark:text-gray-100 mb-4">Delete Wallet</h2>
        
        <div className="bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-700 rounded-lg p-4 mb-4 transition-colors">
          <div className="flex items-start">
            <svg className="w-5 h-5 text-red-600 mt-0.5 mr-2 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <div className="text-sm text-red-800 dark:text-red-300">
              <p className="font-semibold mb-1">Warning: This action cannot be undone!</p>
              <p>Once deleted, you will lose access to this wallet forever.</p>
            </div>
          </div>
        </div>
        
        <div className="space-y-4 mb-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Wallet Name</label>
            <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg text-gray-900 dark:text-gray-100 font-medium transition-colors">
              {wallet.name || `Wallet ${wallet.id}`}
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">Public Address</label>
            <div className="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg font-mono text-xs text-gray-900 dark:text-gray-100 break-all transition-colors">
              {wallet.address}
            </div>
          </div>
          
        </div>
        
        <div className="mb-6">
          <label className="flex items-start cursor-pointer">
            <input
              type="checkbox"
              checked={acknowledged}
              onChange={(e) => setAcknowledged(e.target.checked)}
              className="mt-0.5 mr-3 h-4 w-4 text-red-600 focus:ring-red-500 border-gray-300 rounded"
            />
            <span className="text-sm text-gray-700 dark:text-gray-300">
              I understand that deleting this wallet is permanent.
            </span>
          </label>
        </div>
        
        <div className="flex justify-end space-x-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 dark:text-gray-300 bg-gray-200 dark:bg-gray-600 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmDelete}
            disabled={!acknowledged}
            className={`px-4 py-2 rounded-lg transition-colors ${
              acknowledged
                ? 'bg-red-600 text-white hover:bg-red-700'
                : 'bg-gray-300 dark:bg-gray-600 text-gray-500 dark:text-gray-400 cursor-not-allowed'
            }`}
          >
            Delete Wallet
          </button>
        </div>
      </div>
    </div>
  );
};

export default WalletDeleteModal;